export const CurrrentPatientsPage = (destinationLang) => {
  return [
    {
      FormKey: "general-public-refer-to",
      Key: "ارجاع به",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "current-patients-patient-actions-cancel-referral",
      Key: "انصراف از ارجاع",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "current-patients-patient-actions-list-service-confer",
      Key: "مشاهده خدمات",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "current-patients-patient-actions-end-treatment",
      Key: "پايان فعاليت",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "current-patients-patient-actions-medical-form",
      Key: "پرونده پزشکي",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "current-patients-patient-actions-service-summary",
      Key: "خلاصه پرونده",
      DistinitationLanguage: destinationLang,
    },

    {
      FormKey: "current-patients-search-bar",
      Key: "جستجوي بيمار",
      DistinitationLanguage: destinationLang,
    },

    {
      FormKey: "general-public-label-patient",
      Key: "بیمار",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "general-public-address",
      Key: "آدرس",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "general-public-mobile-number",
      Key: "تلفن همراه",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "general-public-label-diagnose",
      Key: "تشخیص",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "current-patients-alert-confirm-cancel-redirect",
      Key: "آیااز انصراف از ارجاع اطمینان دارید؟",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "current-patients-alert-cancel-successful",
      Key: "با موفقیت لغو شد",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "current-patients-alert-end-treamtment-sure",
      Key: "آیا از پایان فعالیت اطمینان دارید؟",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "current-patients-label-change-presence",
      Key: "آیا از تغییر زمان حضور اطمینان دارید؟",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "current-patients-label-change-detection",
      Key: "آیا از تغییر تشخیص اطمینان دارید؟",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "current-patients-filter-selector-no-service",
      Key: "بدون خدمت",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "current-patients-filter-selector-no-form",
      Key: "بدون پرونده پزشکی",
      DistinitationLanguage: destinationLang,
    },
  ];
};
